module.exports = __webpack_public_path__ + "img/cross3green.ddae689e.png";